"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMockDealDetail = void 0;
const createMockDealDetail = (overwrites = {}) => (Object.assign({ runRateRevenue: undefined, runRateRevenueAsOf: undefined, revenue: undefined, revenueAsOf: undefined, growthRateValue: undefined, growthRateLabelValue: undefined, growthRateAsOfValue: undefined, margins: undefined, marginsAsOf: undefined }, overwrites));
exports.createMockDealDetail = createMockDealDetail;
//# sourceMappingURL=DealDetail.factory.js.map